<template>
  <section class="space-y-4">
    <h2 class="text-base font-medium dark:text-gray-100">
      {{ t("pages.fitrana.faqs.title") }}
    </h2>

    <div class="space-y-2">
      <details
        v-for="(item, index) in faqs"
        :key="index"
        class="rounded-lg border border-gray-200 dark:border-gray-700 p-3 bg-white dark:bg-gray-800"
      >
        <summary class="cursor-pointer text-base font-medium dark:text-gray-100">
          {{ item.question }}
        </summary>
        <p class="mt-2 text-base text-gray-600 dark:text-gray-300 leading-relaxed">
          {{ item.answer }}
        </p>
      </details>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t, tm } = useI18n();
const faqs = computed(
  () =>
    tm("pages.fitrana.faqs.items") as { question: string; answer: string }[],
);
</script>
